module.exports = __webpack_public_path__ + "static/img/Emmanuel-Lagarrigue_2017-18.bf4b550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Emmanuel-Lagarrigue_2017-18.jpg
// module id = MKBd
// module chunks = 0